import { isHttpClientErrorResponse } from '@atlassian/jira-fetch/src/utils/is-error.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';

export const RESOURCE_TYPE_TRIAGE_BUTTON_PERMISSION = 'triage-button-permission';

type Permission = {
	id: string;
	key: string;
	name: string;
	type: string;
	description: string;
	havePermission: boolean;
};

type PermissionResponseShape = {
	permissions: Record<string, Permission>;
};

type AiStatusResponseShape = {
	isEnabled: boolean;
};

export type TriageButtonPermissionData = {
	hasPermission: boolean;
	hasAiEnabled: boolean;
};

export const getTriageButtonPermission = async (): Promise<TriageButtonPermissionData> => {
	const permissionsUrl =
		'/rest/api/3/mypermissions?permissions=MOVE_ISSUES%2CEDIT_ISSUES%2CBULK_CHANGE';
	const aiStatusUrl = '/rest/latest/aiconfig/optin/jira-servicedesk';

	try {
		const [permissions, aiStatus] = await Promise.all([
			performGetRequest<PermissionResponseShape>(permissionsUrl),
			performGetRequest<AiStatusResponseShape>(aiStatusUrl),
		]);

		return {
			hasPermission:
				permissions.permissions.MOVE_ISSUES?.havePermission &&
				permissions.permissions.EDIT_ISSUES?.havePermission &&
				permissions.permissions.BULK_CHANGE?.havePermission,
			hasAiEnabled: aiStatus.isEnabled,
		};
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		if (!isHttpClientErrorResponse(error)) {
			fireErrorAnalytics({
				meta: {
					id: 'fetchTriageButtonPermissionError',
					packageName: 'jiraRouterResourcesServiceDeskQueues',
					teamName: 'jsm-flash',
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
		}

		// Return default values on error
		return {
			hasPermission: false,
			hasAiEnabled: false,
		};
	}
};
